import { Toast } from "primereact/toast";
import { useRef, useState } from "react";
import { EmptyBranch } from "./EmptyBranch";
import { Form } from "./Form";
import { Table } from "./Table";
import { IBranchMast } from "../../models/BranchMast";
import { IPermissionProps } from "../../models/Login";

export interface IModel {
    open: boolean,
    singleData: IBranchMast
}

export const BranchMast = (permissions: IPermissionProps) => {

    const [modal, setModal] = useState({ singleData: EmptyBranch, open: false } as IModel);
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ singleData: EmptyBranch, open: false })
    };


    return (
        <>
            <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload}></Form>
            <Table permissions={permissions} setModal={setModal} toast={toast} reload={reload}></Table>
            <Toast ref={toast} />
        </>
    );
}
